
import { BehaviorSubject } from 'rxjs';

export const behaviorSubjectCheckout$ = new BehaviorSubject({});

export const behaviorSubjectCheckout = behaviorSubjectCheckout$.asObservable();